// Put utility functions here
export const getSyllable = (word, letter) => {
  const stringWord = String(word); // edge case for string "false"
  const letterIndex = stringWord.indexOf(letter);
  return `${stringWord[letterIndex - 1]}${letter}`;
};

export const calculateGlowIndex = tiles => tiles.length - 1;

export const calculateControlledGlowIndex = (tiles, syllable) => {
  let glowIndex = 0;
  tiles.forEach((t, index) => {
    t.forEach((word) => {
      if (word === syllable) {
        glowIndex = index;
      }
    });
  });
  return glowIndex;
};

export const getTwoDigitsNumber = (n) => {
  if (n > 9) {
    return `${n}`;
  }
  return `0${n}`;
};
